import { CommonModule, formatDate } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pop } from 'src/app/classes/shared/pop';
import { MetricModel } from 'src/app/interfaces/api/project';
import { MetricService } from 'src/app/services/api/metrics/metric.service';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { AuthService } from 'src/app/services/core/auth.service';
import { DatePickerComponent } from 'ui-library';

@Component({
  selector: 'app-metric-modif',
  templateUrl: './metric-modif.component.html',
  styleUrls: ['./metric-modif.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogClose,
    MatDialogActions,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    DatePickerComponent,
    TranslateModule
  ]
})

export class MetricModifComponent implements OnDestroy {
  metric: MetricModel;
  project: any;
  inputs: any[] = [];
  payload: any[] = [];
  user: any;
  destroy$ = new Subject<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private metricService: MetricService,
    private pop: Pop,
    private translate: TranslateService,
    private projectService: ProjectService,
    private dialogRef: MatDialogRef<MetricModifComponent>,
    private auth: AuthService) {
    this.user = this.auth.currentUser();

    this.projectService.currentProject.pipe(takeUntil(this.destroy$)).subscribe((project: any) => {
      this.project = project;
    });

    const dataDialog = this.data;
    const customIdInData = dataDialog.infoBox.data.find((d: any) => d.key == "customId")?.value;

    this.metric = this.project.metricModels.find((m: any) => m._id == customIdInData);
    this.metric.payload?.forEach((p: any) => {
      const data = dataDialog.infoBox.data.find((d: any) => d.key === p.label);
      if (data) {
        if (p.type === 'date') {
          try {
            let dateObj: Date;

            if (typeof data.value === 'string') {
              const dateParts = data.value.split(' ');
              const [day, month, year] = dateParts[0].split('/').map(Number);
              const [hours, minutes, seconds] = dateParts[1].split(':').map(Number);

              dateObj = new Date(year, month - 1, day, hours, minutes, seconds);
            } else if (data.value instanceof Date) {
              dateObj = data.value;
            } else {
              throw new Error('Le format de la date est incorrect.');
            }

            p.value = formatDate(dateObj, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
          } catch (error) {
            console.error('Erreur de formatage de date :', error);
          }
        } else {
          p.value = data.value;
        }
      } else {
        p.value = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDateChange(dateEvent: any, config: any): void {
    config.value = dateEvent.startDate || dateEvent;
  }

  saveMetric() {
    let payload: any = {};
    this.metric.payload?.forEach((p: any) => {
      if (p.type == "date") {
        payload[p.label] = new Date(p.value).toISOString();
      } else {
        payload[p.label] = p.value;
      }
    })

    payload["customMetric"] = true;
    payload["customId"] = this.metric._id;

    let metric = {
      id: this.data.infoBox.id,
      name: this.metric.name,
      user: this.user.id,
      userEmail: this.user.email,
      modifiedDate: new Date().toISOString(),
      payload,
    }

    this.metricService.setMetric(metric).subscribe((res: any) => {
      this.pop.toast(this.translate.instant('events.metric_saved'), "success", 4000, "save");
      this.dialogRef.close(metric);
    },
      (error: any) => {
        this.pop.error(this.translate.instant('events.metric_errored'));
      })
  }
}
